import 'core-js/es6/array';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter, Switch, Route, Link } from "react-router-dom";

import StepMemberEligibility from './Components/Steps/StepMemberEligibility';
import StepProspectMemberEligibility from './Components/Steps/StepProspectMemberEligibility';
import StepBasicIdentity from './Components/Steps/StepBasicIdentity';
import StepExtendedIdentity from './Components/Steps/StepExtendedIdentity';
import StepContactInfo from './Components/Steps/StepContactInfo';
import StepEmploymentDetails from './Components/Steps/StepEmploymentDetails';
import StepCoApplicantCheck from './Components/Steps/StepCoApplicantCheck';
import StepCoApplicantIdentity from './Components/Steps/StepCoApplicantIdentity';
import StepCoApplicantContact from './Components/Steps/StepCoApplicantContact';
import StepCoApplicantEmployment from './Components/Steps/StepCoApplicantEmployment';
import { StepBalanceTransfer, StepBalanceTransferDetail, StepBalanceTransferInfo } from './Components/Steps/StepBalanceTransfer';
import { StepAuthorizedUser, StepAuthorizedUserDetail, StepAuthorizedUserInfo } from './Components/Steps/StepAuthorizedUser';
import StepDisclosures from './Components/Steps/StepDisclosures';
import StepFinalAgreements from './Components/Steps/StepFinalAgreements';
import StepCompleted from './Components/Steps/StepCompleted';
import StepNotFound from './Components/Steps/StepNotFound';

// Where to mount this react app in index.html
var mounts = document.getElementById('loan_app');

/////////////////////////
// HELPER FUNCTIONS TO UPDATE CoAPPLICANT STATE
/////////////////////////
// Setter - coApp
export function setCoAppState(val) {
    //console.log("CoAppState:" + val);
    this.setState({ coApp: val });
}

// Getter - CoApp
export function getCoAppState() {
    return (this.state.coApp);
}

/////////////////////////
// HELPER FUNCTIONS FOR BALANCE TRANSFER (CRUD + RESET)
/////////////////////////
export function addBalanceTransferObject() {
    var balanceTransferObject = {
        Id:getApp('btIndex'),
        LenderName: getApp('btLenderName'),
        // LenderAccount: getApp('btCreditCardNumber'),
        LenderAmount: getApp('btTransferAmount')
        // Address: getApp('btLenderAddress'),
        // City: getApp('btLenderCity'),
        // State: getApp('btLenderState'),
        // ZipCode: getApp('btLenderZip')
    }

    this.setState(prevState => ({
        balanceTransferArray: [...prevState.balanceTransferArray, balanceTransferObject]
    }));
}

export function editBalanceTransferObject(index) {

    //Create a copy of current array of BTArray to prevent mutating
    let currentBalanceTransferArray = [...getApp('balanceTransferArray')];
    currentBalanceTransferArray[index].LenderName = getApp('btLenderName');
    // currentBalanceTransferArray[index].LenderAccount = getApp('btCreditCardNumber');
    currentBalanceTransferArray[index].LenderAmount = getApp('btTransferAmount');
    // currentBalanceTransferArray[index].Address = getApp('btLenderAddress');
    // currentBalanceTransferArray[index].City = getApp('btLenderCity');
    // currentBalanceTransferArray[index].State = getApp('btLenderState');
    // currentBalanceTransferArray[index].ZipCode = getApp('btLenderZip');

    setApp('balanceTransferArray', currentBalanceTransferArray);
}

export function deleteBalanceTransferObject(index) {
    let currentBalanceTransferArray = [...getApp('balanceTransferArray')];
    currentBalanceTransferArray.splice(index, 1);
    setApp('balanceTransferArray', currentBalanceTransferArray);
}

export function resetBalanceTransferObject() {
    let currentBalanceTransferArray = [];
    this.setState({
        balanceTransferArray: currentBalanceTransferArray
    });
}

/////////////////////////
// HELPER FUNCTIONS FOR AUTHORIZED USERS (CRUD + RESET)
/////////////////////////
export function addAuthorizedUserObject() {
    var authorizedUserObject = {
        Id:getApp('asIndex'),
        FirstName: getApp('as_fname'),
        MiddleName: getApp('as_mname'),
        LastName: getApp('as_lname'),
        DOB: getApp('as_dob'),
        SSN: getApp('as_ssn')
    }

    this.setState(prevState => ({
        authorizedUserArray: [...prevState.authorizedUserArray, authorizedUserObject]
    }));
}

export function editAuthorizedUserObject(index) {

    //Create a copy of current array of ASArray to prevent mutating
    let currentAuthorizedUserArray = [...getApp('authorizedUserArray')];
    currentAuthorizedUserArray[index].FirstName = getApp('as_fname');
    currentAuthorizedUserArray[index].MiddleName = getApp('as_mname');
    currentAuthorizedUserArray[index].LastName = getApp('as_lname');
    currentAuthorizedUserArray[index].DOB = getApp('as_dob');
    currentAuthorizedUserArray[index].SSN = getApp('as_ssn');

    setApp('authorizedUserArray', currentAuthorizedUserArray);
}

export function deleteAuthorizedUserObject(index) {
    let currentAuthorizedUserArray = [...getApp('authorizedUserArray')];
    currentAuthorizedUserArray.splice(index, 1);
    setApp('authorizedUserArray', currentAuthorizedUserArray);
}

export function resetAuthorizedUserObject() {
    let currentAuthorizedUserArray = [];
    this.setState({
        authorizedUserArray: currentAuthorizedUserArray
    });
}

/////////////////////////
// HELPER FUNCTIONS FOR PROGRESS BAR
/////////////////////////
// Update Progress Bar Ribbon
export function updateProgress(per, progLabel) {
    //console.log("Progress: " + per + ", Label: " + progLabel);
    this.setState({
        progress: per,
        progLabel: progLabel
    });
}

// Update Back Navigation Link
export function updateBackLink(link) {
    //console.log("BackLink: " + link);
    this.setState({ backLink: link });
}

/////////////////////////
// HELPER FUNCTIONS FOR MAIN STATE
/////////////////////////
// Set state based on key, value pair
export function setApp(key, value) {
    //console.log("Key: " + key + ", value: " + value);
    this.state[key] = value;
    //console.log("State After Updating: ", JSON.stringify(this.state));
}

// Return a value of a state
export function getApp(specificState) {
    var returnState = this.state[specificState];
    //console.log("Return State: " + returnState);
    return returnState;
}

// Return entire state object
export function getAllStates() {
    return this.state;
}

/////////////////////////
// URL ROUTING
/////////////////////////
class Main extends React.Component {
    render() {
        return (
            <main>
                <Switch>
                    <Route exact path='/loan-application' component={StepMemberEligibility} />
                    <Route exact path='/loan-application/eligibility' component={StepProspectMemberEligibility} />
                    <Route exact path='/loan-application/identity' component={StepBasicIdentity} />
                    <Route exact path='/loan-application/verification' component={StepExtendedIdentity} />
                    <Route exact path='/loan-application/address' component={StepContactInfo} />
                    <Route exact path='/loan-application/work' component={StepEmploymentDetails} />
                    <Route exact path='/loan-application/co-applicant' component={StepCoApplicantCheck} />
                    <Route exact path='/loan-application/co-applicant-info' component={StepCoApplicantIdentity} />
                    <Route exact path='/loan-application/co-applicant-contact' component={StepCoApplicantContact} />
                    <Route exact path='/loan-application/co-applicant-work' component={StepCoApplicantEmployment} />
                    <Route exact path='/loan-application/balance-transfer' component={StepBalanceTransfer} />
                    <Route exact path='/loan-application/balance-transfer-detail' component={StepBalanceTransferDetail} />
                    <Route exact path='/loan-application/balance-transfer-info' component={StepBalanceTransferInfo} />
                    <Route exact path='/loan-application/authorized-user' component={StepAuthorizedUser} />
                    <Route exact path='/loan-application/authorized-user-detail' component={StepAuthorizedUserDetail} />
                    <Route exact path='/loan-application/authorized-user-info' component={StepAuthorizedUserInfo} />
                    <Route exact path='/loan-application/disclosures' component={StepDisclosures} />
                    <Route exact path='/loan-application/final-review' component={StepFinalAgreements} />
                    <Route exact path='/loan-application/overview' component={StepCompleted} />
                    <Route exact path='/loan-application/not-found' component={StepNotFound} />
                </Switch>
            </main>
        )
    }
}

/////////////////////////
// FULL APP
/////////////////////////
class LoanApp extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            step: 1,
            coApp: false,
            progress: "2%",
            backLink: "/",
            currentMember: false,
            currentActiveAz: false,
            product: "",
            fname: "",
            mname: "",
            lname: "",
            email: "",
            phone: "",
            phoneType: "",
            auth1: true,
            userip: "",
            dob: "",
            ssn: "",
            maritalStatus: "",
            address: "",
            address2: "",
            city: "",
            state: "",
            zipcode: "",
            mailingCheck: false,
            mailingAddress: "",
            mailingAddress2: "",
            mailingCity: "",
            mailingState: "",
            mailingZipcode: "",
            ownershipStatus: "",
            saveMailingAddress: "",
            saveMailingAddress2: "",
            saveMailingCity: "",
            saveMailingState: "",
            saveMailingZipcode: "",
            saveMwnershipStatus: "",
            monthlyPayment: "",
            yearsAtAddress: "",
            monthsAtAddress: "",
            employmentStatus: "",
            employer: "",
            incomeSource: "",
            companyName: "",
            yearsEmployer: "",
            monthsEmployer: "",
            position: "",
            annualIncome: "",
            vwEmployee: false,
            coApplicantType: "",
            coApplicant: "",
            ca_fname: "",
            ca_mname: "",
            ca_lname: "",
            ca_dob: "",
            ca_ssn: "",
            ca_email: "",
            sameAddress: "",
            caAddress: "",
            caAddress2: "",
            caCity: "",
            caState: "",
            caZip: "",
            caMonthlyPayment: "",
            coAppMailingAddress: "",
            coAppMailingAddress2: "",
            coAppMailingCity: "",
            coAppMailingState: "",
            coAppMailingZipcode: "",
            saveCoAppMailingAddress: "",
            saveCoAppMailingAddress2: "",
            saveCoAppMailingCity: "",
            saveCoAppMailingState: "",
            saveCoAppMailingZipcode: "",
            caPhone: "",
            caPhoneType: "",
            caEmploymentStatus: "",
            caEmployer: "",
            caCompanyName: "",
            caYearsEmployer: "",
            caMonthsEmployer: "",
            caPosition: "",
            caIncomeSource: "",
            caAnnualIncome: "",
            caVWEmployee: false,
            balanceTransfer:"",
            balanceTransferArray: [],
            btIndex: -1,
            btCounter:0,
            btMax:3,
            btLenderName: "",
            btCreditCardNumber: "",
            btTransferAmount: "",
            btLenderAddress: "",
            btLenderCity: "",
            btLenderState: "",
            btLenderZip: "",
            authorizedUser: "",
            authorizedUserArray: [],
            asIndex: -1,
            asCount: 0,
            asMax:3,
            as_fname: "",
            as_mname: "",
            as_lname: "",
            as_dob: "",
            as_ssn: "",
            asDisclosure: false,
            promoCode: "",
            // promoCodeNeedValidate: false,
            blockPromo: false,
            applicationDisclosure: false,
            solicitationDisclosure: false,
            membershipQualification: false,
            agreement: "",
            review: false,
            requestType: "new",
            blockAgreements: true,
            blockZeros: true,
            blockDisclosures: true,
            blockAuDisclosure : false,
            blockAge: false,
            caBlockAge: false,
            auBlockAge: false,
            recaptchaVerify: false,
            prim_enc: "",
            coapp_enc: ""
        }
        setCoAppState = setCoAppState.bind(this);
        getCoAppState = getCoAppState.bind(this);
        addBalanceTransferObject = addBalanceTransferObject.bind(this);
        editBalanceTransferObject = editBalanceTransferObject.bind(this);
        deleteBalanceTransferObject = deleteBalanceTransferObject.bind(this);
        resetBalanceTransferObject = resetBalanceTransferObject.bind(this);
        addAuthorizedUserObject = addAuthorizedUserObject.bind(this);
        editAuthorizedUserObject = editAuthorizedUserObject.bind(this);
        deleteAuthorizedUserObject = deleteAuthorizedUserObject.bind(this);
        resetAuthorizedUserObject = resetAuthorizedUserObject.bind(this);
        updateProgress = updateProgress.bind(this);
        updateBackLink = updateBackLink.bind(this);
        setApp = setApp.bind(this);
        getApp = getApp.bind(this);
        getAllStates = getAllStates.bind(this);
        this.exitApplication = this.exitApplication.bind(this);
    }

    componentDidMount() {
        //loadReCaptcha("6Lczy6sUAAAAAOqv23T0j3arfnK2yRnP9a98QFZT");
    }

    exitApplication() {
        var exitLink;
        var source = document.location.origin;

        if (source.indexOf('vantagewest.org') !== -1 || source.indexOf('vantagewest.com') !== -1) {
            exitLink = document.location.origin;
        } else {
            exitLink = "https://www.vantagewest.org";
        }
        
        if(window.confirm("Are you sure you want to exit this application? The information you provided will be lost."))
            window.location = exitLink;
    }

    render() {
        var productName = getApp('product');

        return (
            <div className="hug">
                <div className="loanApp-wrap" style={{ width: "100%", margin: "0 auto", position: "relative", float: "left" }}>
                    <div className="top-bar">
                        <div className="hug upper-bar">
                            <Link to={this.state.backLink} className="back-btn button">Back</Link>
                            <a className="exit-btn button" onClick={this.exitApplication} style={{"cursor": "pointer"}}>Exit</a>
                            <div className="hug">
                                <span className="top-bar-text">{productName ? productName : "Undefined Product"} Application</span>
                            </div>
                        </div>
                        <div className="hug lower-bar">
                            <div className="step-progress">
                                <span className="progress-bar" style={{ width: this.state.progress }}></span>
                                <span className="progress-bar-label" style={{ left: this.state.progress }}>{this.state.progLabel}</span>
                            </div>
                        </div>
                    </div>
                    <Main />
                </div>
            </div>
        );
    }
}

ReactDOM.render((
    <BrowserRouter>
        <LoanApp />
    </BrowserRouter>
), mounts);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA